@if (formGroup && isMailTemplateIdsLoaded) {
    <form (ngSubmit)="saveConfiguration()" [formGroup]="formGroup" class="form-container">
        <div class="title-header">
            <span class="flex-1">{{ 'organisation.communication' | translate }}</span>
            <button class="icon-button icon-close" mat-dialog-close="" type="button"></button>
        </div>
        <div class="scroll-container">
            <div class="content">
                <div class="form-section">
                    <div class="flex-row">
                        <div class="form-cell flex-1">
                            <sag-ui-switch formControlName="isEnabled">
                                {{ 'organisation.communication.automated' | translate }}
                            </sag-ui-switch>
                        </div>
                        @if (isOrgNode) {
                            <div class="flex-1 form-cell label-checkbox">
                                <sag-ui-checkbox formControlName="inheritAllSettingsFromParent">
                                    {{ 'organisation.communication.inherit' | translate }}
                                </sag-ui-checkbox>
                            </div>
                        }
                    </div>
                </div>
                <div class="form-section form-section--parent">
                    <ng-container [ngTemplateOutlet]="responsibleMail" />
                    <ng-container [ngTemplateOutlet]="specialistMail" />
                    <ng-container [ngTemplateOutlet]="reminderMail" />
                </div>
            </div>
        </div>
        <div class="form-button-container">
            <sag-ui-button [type]="'submit'">
                {{ 'default.buttons.save' | translate }}
            </sag-ui-button>
        </div>
    </form>
}

<ng-template #specialistMail>
    @if (!communicationTemplateFormGroup(OrganisationCommunicationType.specialist)) {
        <div class="form-section-item"></div>
    } @else {
        <div
            [formGroup]="communicationTemplateFormGroup(OrganisationCommunicationType.specialist)"
            class="form-section-item"
        >
            <sag-ui-switch formControlName="isEnabled">
                {{ 'organisation.communication.mailPS' | translate }}
            </sag-ui-switch>
            <sag-ui-input
                class="flex-1"
                label="{{ 'organisation.communication.templateId.label' | translate }}"
                [value]="
                    communicationTemplateFormGroup(OrganisationCommunicationType.specialist).get('isEnabled')?.value
                        ? templateId(OrganisationCommunicationType.specialist)
                        : ('organisation.communication.templateId.deactivated' | translate)
                "
                [readOnly]="true"
                [disabled]="
                    !communicationTemplateFormGroup(OrganisationCommunicationType.specialist).get('isEnabled')?.value
                "
            />
            <sag-ui-input
                class="flex-1"
                formControlName="sendAt"
                [type]="'date'"
                [timeFormat]="'hh:mm'"
                [placeholder]="'MM/DD/YYYY'"
                (dateChange)="IS_TRS_PROJECT ? pickerSpecialistFilter($event) : null"
            />
            <div class="form-cell flex-1 label-checkbox">
                <sag-ui-checkbox formControlName="includeOtherArea">
                    {{ 'organisation.communication.includeCEO' | translate }}
                </sag-ui-checkbox>
            </div>
            <sag-ui-button
                class="form-cell"
                type="button"
                icon="mail"
                [disabled]="
                    communicationTemplateFormGroup(OrganisationCommunicationType.specialist).get('ccRecipients')!
                        .disabled
                "
                (click)="openCcRecipientsDialog(OrganisationCommunicationType.specialist)"
            >
                {{ 'organisation.communication.cc.manage' | translate }}
            </sag-ui-button>
        </div>
    }
</ng-template>

<ng-template #responsibleMail>
    @if (!communicationTemplateFormGroup(OrganisationCommunicationType.responsible)) {
        <div class="form-section-item"></div>
    } @else {
        <div
            [formGroup]="communicationTemplateFormGroup(OrganisationCommunicationType.responsible)"
            class="form-section-item"
        >
            <sag-ui-switch formControlName="isEnabled">
                {{ 'organisation.communication.mailCEO' | translate }}
            </sag-ui-switch>
            <sag-ui-input
                class="flex-1"
                label="{{ 'organisation.communication.templateId.label' | translate }}"
                [value]="
                    communicationTemplateFormGroup(OrganisationCommunicationType.responsible).get('isEnabled')?.value
                        ? templateId(OrganisationCommunicationType.responsible)
                        : ('organisation.communication.templateId.deactivated' | translate)
                "
                [readOnly]="true"
                [disabled]="
                    !communicationTemplateFormGroup(OrganisationCommunicationType.responsible).get('isEnabled')?.value
                "
            />
            <sag-ui-input
                class="flex-1"
                formControlName="sendAt"
                [type]="'date'"
                [timeFormat]="'hh:mm'"
                [placeholder]="'MM/DD/YYYY'"
                (dateChange)="IS_TRS_PROJECT ? pickerResponsibleFilter($event) : null"
            />

            <div class="form-cell flex-1 label-checkbox">
                <sag-ui-checkbox formControlName="includeOtherArea">
                    {{ 'organisation.communication.includePS' | translate }}
                </sag-ui-checkbox>
            </div>
            <sag-ui-button
                class="form-cell"
                type="button"
                icon="mail"
                [disabled]="
                    communicationTemplateFormGroup(OrganisationCommunicationType.responsible).get('ccRecipients')!
                        .disabled
                "
                (click)="openCcRecipientsDialog(OrganisationCommunicationType.responsible)"
            >
                {{ 'organisation.communication.cc.manage' | translate }}
            </sag-ui-button>
        </div>
    }
</ng-template>

<ng-template #reminderMail>
    <div [formGroup]="communicationTemplateFormGroup(OrganisationCommunicationType.reminder)" class="form-section-item">
        <sag-ui-switch formControlName="isEnabled">
            {{ 'organisation.communication.reminder' | translate }}
        </sag-ui-switch>
        <sag-ui-input
            class="flex-1"
            label="{{ 'organisation.communication.templateId.label' | translate }}"
            [value]="
                communicationTemplateFormGroup(OrganisationCommunicationType.reminder).get('isEnabled')?.value
                    ? templateId(OrganisationCommunicationType.reminder)
                    : ('organisation.communication.templateId.deactivated' | translate)
            "
            [readOnly]="true"
            [disabled]="!communicationTemplateFormGroup(OrganisationCommunicationType.reminder).get('isEnabled')?.value"
        />
        <sag-ui-input
            class="flex-1"
            formControlName="sendAt"
            [type]="'date'"
            [timeFormat]="'hh:mm'"
            [placeholder]="'MM/DD/YYYY'"
            (dateChange)="pickerReminderFilter($event)"
        />
        <div class="form-cell flex-1 label-checkbox">
            <sag-ui-checkbox formControlName="includeOtherArea">
                {{ 'organisation.communication.includeCEO' | translate }}
            </sag-ui-checkbox>
        </div>
        <sag-ui-button
            class="form-cell"
            type="button"
            icon="mail"
            [disabled]="
                communicationTemplateFormGroup(OrganisationCommunicationType.reminder).get('ccRecipients')!.disabled
            "
            (click)="openCcRecipientsDialog(OrganisationCommunicationType.reminder)"
        >
            {{ 'organisation.communication.cc.manage' | translate }}
        </sag-ui-button>
    </div>
</ng-template>
